/**
 * Created by akirilyuk on 9/15/16.
 */
define(function (require) {
    "use strict";
    var LE = require("app"),
        Multiselect = require("ui/multiselect/Multiselect"),
        SearchFilterController = require("connection-controllers/ticketTab/SearchFilterController"),
        Button = require("ui/button/Button"),
        template = require("connection-templates/ticketTab/extendedList/searchFilterLayout.tmpl"),
        SearchFilterView = {};

    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        SearchFilterView = Marionette.ItemView.extend({
            className: 'extended-list-search-filter-layout',
            template: template,

            ui: {
                closeButton: ".close-filter",
                statusInput: ".status-input-container .status-input-field",
                accountIdInput: ".accountid-input-container .accountid-input-field",
                accountNameInput: ".accountname-input-container .accountname-input-field",
                businessInput: ".business-input-container .business-input-field",
                nameInput: ".name-input-container .name-input-field",
                resetButton: ".reset-filter-button",
                cancelButton: ".cancel-filter-button",
                filterButton: ".filter-button"

            },

            uiComponents: {
                statusInput: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.statusInput",
                        permutation: Multiselect.PERMUTATION.MEDIUM,
                        items: "view._getStatusItems"
                    }
                },
                accountIdInput: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.accountIdInput",
                        permutation: Multiselect.PERMUTATION.MEDIUM,
                        items: "view._getAccountIdItems"
                    }
                },
                accountNameInput: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.accountNameInput",
                        permutation: Multiselect.PERMUTATION.MEDIUM,
                        items: "view._getAccountNameItems"
                    }
                },
                businessInput: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.businessInput",
                        permutation: Multiselect.PERMUTATION.MEDIUM,
                        items: "view._getBusinessItems"
                    }
                },
                nameInput: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.nameInput",
                        permutation: Multiselect.PERMUTATION.MEDIUM,
                        items: "view._getNameItems"
                    }
                },
                resetButton: {
                    type: Button,
                    options: {
                        el: "view.ui.resetButton"
                    },
                    events: {
                        click: "_onReset"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton"
                    },
                    events: {
                        click: "_onCancel"
                    }
                },
                filterButton: {
                    type: Button,
                    options: {
                        el: "view.ui.filterButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        click: "_onFilter"
                    }
                }
            },
            events: {
                "click @ui.closeButton": "_onClose",
                "clickoutside": "_onClickOutside"
            },

            initialize: function (options) {
                this.initFilterOptions = options.initFilterOptions;
                this.hidden = options.hidden;
                this.triggerElement = options.triggerElement;
                this.container = options.el;
                this.closeOnClickOutside = options.closeOnClickOutside;
                this.searchFilterController = new SearchFilterController({
                    collection: options.collection,
                    filterLayout: this
                });
                this._bindEvents();
            },

            onRender: function () {
                this.container.append(this);
                if (this.hidden) {
                    this._hide();
                }
                //set the filter options
                this._initializeFilterOptions();
                //hide businesInput
                this.uiComponents.businessInput.$el.addClass("hide");
            },

            _bindEvents: function () {
                this.listenTo(this.searchFilterController, "collection::filtered", this._updateOptionItems);
            },

            _updateOptionItems: function () {
                this._setOptionsItems(this.searchFilterController.getCurrentOptionItems());
            },

            _initializeFilterOptions: function () {
                this._setOptionsItems(this.searchFilterController.getInitialOptionItems());
            },

            _setOptionsItems: function (optionsItems) {
                if (this.uiComponents.accountIdInput.setItems) {
                    this.uiComponents.accountIdInput.setItems(optionsItems.accountid);
                }
                if (this.uiComponents.accountNameInput.setItems) {
                    this.uiComponents.accountNameInput.setItems(optionsItems.accountName);
                }
                if (this.uiComponents.businessInput.setItems) {
                    this.uiComponents.businessInput.setItems(optionsItems.business);
                }
                if (this.uiComponents.statusInput.setItems) {
                    this.uiComponents.statusInput.setItems(optionsItems.status);
                }
                if (this.uiComponents.nameInput.setItems) {
                    this.uiComponents.nameInput.setItems(optionsItems.name);
                }
            },

            _getSelectedItems: function () {
                var selectedValues = {
                    statusValues: this.uiComponents.statusInput.getSelectedItems(),
                    accountNameValues: this.uiComponents.accountNameInput.getSelectedItems(),
                    accountIdValues: this.uiComponents.accountIdInput.getSelectedItems(),
                    businessValues: this.uiComponents.businessInput.getSelectedItems(),
                    nameValues: this.uiComponents.nameInput.getSelectedItems()
                };
                return selectedValues;
            },

            //-----INIT THE ITEMS
            _getAccountIdItems: function () {
                if (this.initFilterOptions && this.initFilterOptions.accountid) {
                    return this.initFilterOptions.accountid;
                }
            },

            _getAccountNameItems: function () {
                if (this.initFilterOptions && this.initFilterOptions.accountName) {
                    return this.initFilterOptions.accountName;
                }
            },

            _getStatusItems: function () {
                if (this.initFilterOptions && this.initFilterOptions.status) {
                    return this.initFilterOptions.status;
                }
            },

            _getBusinessItems: function () {
                if (this.initFilterOptions && this.initFilterOptions.business) {
                    return this.initFilterOptions.business;
                }
            },

            _getNameItems: function () {
                if (this.initFilterOptions && this.initFilterOptions.name) {
                    return this.initFilterOptions.name;
                }
            },

            //-----BUTTON AND EVENT FUNCTIONS --------

            _onClose: function () {
                this._hide();
            },

            _onReset: function () {
                this._triggerReset();
            },

            _onCancel: function () {
                this._triggerCancel();
            },

            _onFilter: function () {
                var selectedValues = this._getSelectedItems();
                this._triggerFilter(selectedValues);
            },

            _onClickOutside: function (element) {
                if (this.closeOnClickOutside) {
                    if (this.getIsRendered()) {
                        var triggerParent = $(this.triggerElement)[0];
                        if (element.target == triggerParent || triggerParent.contains(element.target)) {
                            //do nothing, element was called from triggerObject like button or something
                        } else {
                            this._onClose();
                        }
                    }
                }
            },
            
            _triggerFilter: function (values) {
                this.searchFilterController.filter(values);
                this.trigger("filter:active");
            },

            _triggerReset: function () {
                this._unSelectAll();//unselect all values
                var selectedValues = this._getSelectedItems();
                this._triggerFilter(selectedValues);//trigger filter with no values set-> reset
                this._unSelectAll();
                this.trigger("filter:passive");
            },

            _triggerCancel: function () {
                this._triggerReset();
                this._hide();
            },

            _unSelectAll: function () {
                _.each(this.uiComponents, function (value) {
                    if (_.isFunction(value.unselectAll)) {
                        value.unselectAll();
                    }
                });
            },

            _hide: function () {
                $(this.$el).addClass("hide");
                this.trigger("filter:closed");
            },

            _show: function () {
                $(this.$el).removeClass("hide");
            }
        });
    });
    return SearchFilterView;
});
